import React from 'react';
import { graphql, compose } from 'react-apollo';
import { allVideosQuery } from '../graphql/all-videos-query';
import { VideosView } from './videos.component';
import { connect } from 'react-redux';
import { updateVideosFilter, editEntity } from '../videos.actions';
import { removeVideoMutation } from '../graphql/remove-video.mutation';
import { withStatistics } from '../../common/components/with-statistics.container';

const mapStateToProps = ({ videos }) => ({
  skip: videos.skip,
  limit: videos.limit,
  search: videos.search,
  yocasType: videos.yocasType,
  editModalOpen: videos.isEditMode,
  editModeEntity: videos.editEntity
});

const mapDispatch = dispatch => ({
  updateFilter: filterChanges => dispatch(updateVideosFilter(filterChanges)),
  toggleEditMode: entity => dispatch(editEntity(entity))
});

const withState = connect(mapStateToProps, mapDispatch);

const withData = graphql(allVideosQuery, {
  name: 'videosData',
  options: props => {
    let extraVars = {
      perferedIds: []
    };

    if (
      props.search === '' &&
      props.checkedItems &&
      props.checkedItems.length > 0
    ) {
      extraVars = {
        perferedIds: props.checkedItems
          .map(group =>
            group.startsWith('video_') ? group.replace('video_', '') : null
          )
          .filter(item => item)
      };
    }

    const variables = {
      skip: props.skip,
      limit: props.limit,
      search: props.search,
      yocasType: props.yocasType,
      ...extraVars
    };

    console.log('Videos GraphQL query variables:', variables);

    return {
      fetchPolicy: 'network-only',
      variables,
      errorPolicy: 'all'
    };
  },
  props: ({ videosData, ownProps }) => {
    console.log('Videos GraphQL data:', videosData);
    console.log('Videos GraphQL loading:', videosData?.loading);
    console.log('Videos GraphQL error:', videosData?.error);
    console.log('Videos GraphQL networkStatus:', videosData?.networkStatus);
    
    if (videosData?.error) {
      console.error('Videos GraphQL error details:', videosData.error);
    }
    
    // Structure the data to match what the component expects
    const videos = {
      loading: videosData?.loading || false,
      error: videosData?.error || null,
      allVideos: videosData?.allVideos || {
        total: 0,
        totalForFilter: 0,
        items: []
      },
      refetch: videosData?.refetch || (() => {}),
      networkStatus: videosData?.networkStatus || 0
    };
    
    console.log('Structured videos data:', videos);
    
    return {
      ...ownProps,
      videos,
      loading: videos.loading,
      error: videos.error,
      refetch: videos.refetch,
      networkStatus: videos.networkStatus
    };
  }
});

export const withVideos = compose(withState, withData);

const withMutation = graphql(removeVideoMutation, {
  options: {
    refetchQueries: ['allVideos', 'statistics']
  },
  props: ({ mutate }) => ({
    removeVideo: videoId => mutate({ variables: { videoId } })
  })
});

export const Videos = withStatistics(withVideos(withMutation(VideosView)));
export default Videos;
